function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.65
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 2,
  fill: "#37556A",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 14H6v-3.571C6 7.13 6.028 7 9 7v1.5c-1.737 0-1.286.008-1.286 1.929H9V14zM13 14h-3v-3.571C10 7.13 10.028 7 13 7v1.5c-1.737 0-1.286.008-1.286 1.929H13V14z",
  fill: "#fff"
}));
function SvgBlockQuoteActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
}
export default SvgBlockQuoteActive;